<template>
  <CustDialogBox
    @closed="dialogOnCloseFn"
    :show="isShow"
    title="设置手机号"
    width="450"
  >
    <template #content>
      <div class="dialog_box">
        <el-form
          ref="applyRuleFormRef"
          style="width: 100%"
          :model="applyForm"
          :rules="applyRules"
          label-width="300"
          label-position="top"
          require-asterisk-position="right"
        >
          <el-form-item label="原手机号" prop="phone">
            <el-row style="width: 100%; position: relative">
              <el-input
                disabled
                placeholder="请输入"
                :maxlength="11"
                v-model="applyForm.phone"
              />
              <el-link
                underline="never"
                style="
                  position: absolute;
                  right: 10px;
                  top: -30px;
                  font-size: 12px;
                  color: #666666;
                "
                @click="loseFn"
              >
                旧手机号已遗失?
              </el-link>
            </el-row>
          </el-form-item>
          <el-form-item label="旧手机号验证码" prop="oldCode">
            <el-row style="width: 100%">
              <el-col :span="16">
                <el-input
                  placeholder="请输入"
                  :maxlength="6"
                  v-model="applyForm.oldCode"
                  @input="validateSmsCodeFn"
                />
              </el-col>
              <el-col :span="8" style="text-align: end">
                <el-button @click="sendOldCode" :disabled="isOldCounting">
                  {{ buttonOldText }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="新手机号" prop="newPhone">
            <el-input
              placeholder="请输入"
              :maxlength="11"
              v-model="applyForm.newPhone"
              :disabled="isDisable"
            />
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-row style="width: 100%">
              <el-col :span="16">
                <el-input
                  placeholder="请输入"
                  :maxlength="6"
                  v-model="applyForm.code"
                  :disabled="isDisable"
                />
              </el-col>
              <el-col :span="8" style="text-align: end">
                <el-button
                  @click="sendCode"
                  :disabled="isCounting || isDisable"
                >
                  {{ buttonText }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template #footer>
      <div class="dialog_footer">
        <el-button type="primary" @click="dialogSubmit(applyRuleFormRef)">
          提交
        </el-button>
      </div>
    </template>
  </CustDialogBox>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { sendSmsCode, updateMobile, validateSmsCode } from '@/api/login'
const userStore = useUserStore()
const emit = defineEmits(['closed', 'update:isShow'])
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
})
const applyForm = reactive({
  phone: userStore.getUserInfo?.username ?? '',
  code: '',
  oldCode: '',
  newPhone: '',
})
const applyRuleFormRef = ref()
const applyRules = reactive({
  phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
  code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }],
  oldCode: [
    { required: true, message: '旧手机验证码不能为空', trigger: 'blur' },
  ],
  newPhone: [{ required: true, message: '新手机号不能为空', trigger: 'blur' }],
})
const countdown = ref(0)
const isCounting = ref(false)
let timer = null
let oldTimer = null
const oldCountdown = ref(0)
const isOldCounting = ref(false)
const isDisable = ref(true)
const buttonText = computed(() => {
  return isCounting.value ? `${countdown.value}秒后重新获取` : '获取验证码'
})
const buttonOldText = computed(() => {
  return isOldCounting.value
    ? `${oldCountdown.value}秒后重新获取`
    : '获取验证码'
})

const clearCountdown = () => {
  clearInterval(timer)
  clearInterval(oldTimer)
  timer = null
  oldTimer = null
  countdown.value = 0
  oldCountdown.value = 0
  isCounting.value = false
  isOldCounting.value = false
}

const resetDialogState = async () => {
  clearCountdown()
  Object.assign(applyForm, {
    phone: userStore.getUserInfo?.username ?? '',
    code: '',
    oldCode: '',
    newPhone: '',
  })
  isDisable.value = true
  await nextTick()
  applyRuleFormRef.value?.clearValidate()
}

watch(
  () => props.isShow,
  isShow => {
    if (isShow) resetDialogState()
  }
)

const sendCode = async () => {
  if (isCounting.value) return
  if (applyForm.newPhone.trim().length != 11) {
    ElMessage.warning('请输入正确的手机号')
    return
  }
  const res = await sendSmsCode({ mobile: applyForm.newPhone, scene: 24 })
  if (res.code == 0) {
    ElMessage.success('发送成功')
  }
  startCountdown()
}
const startCountdown = () => {
  isCounting.value = true
  countdown.value = 60
  timer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(timer)
      isCounting.value = false
    }
  }, 1000)
}

const sendOldCode = async () => {
  if (isOldCounting.value) return
  const res = await sendSmsCode({ mobile: applyForm.phone, scene: 24 })
  if (res.code == 0) {
    ElMessage.success('发送成功')
  }
  startOldCountdown()
}
const startOldCountdown = () => {
  isOldCounting.value = true
  oldCountdown.value = 60
  oldTimer = setInterval(() => {
    oldCountdown.value--
    if (oldCountdown.value <= 0) {
      clearInterval(oldTimer)
      isOldCounting.value = false
    }
  }, 1000)
}
onBeforeUnmount(() => {
  clearCountdown()
})
const dialogOnCloseFn = () => {
  resetDialogState()
  emit('closed')
  emit('update:isShow', false)
}
const dialogSubmit = async formEl => {
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      const res = await updateMobile({
        mobile: applyForm.newPhone,
        code: applyForm.code,
      })
      if (res.code == 0) {
        ElMessage.success('修改成功')
        userStore.initUserInfo()
        dialogOnCloseFn()
      }
    }
  })
}
const loseFn = () => {
  ElMessageBox.alert(
    '请联系一对一客服处理,需要提供相关证明是本人账号',
    '手机号遗失处理',
    {
      type: 'warning',
      confirmButtonText: '知道了',
      callback: () => {},
    }
  )
}
const validateSmsCodeFn = async val => {
  if (val.length < 6) {
    return
  }
  const res = await validateSmsCode({
    mobile: applyForm.phone,
    scene: 24,
    code: val,
  })
  if (res.code == 0 && res.data) {
    isDisable.value = false
  }
}
</script>

<style lang="scss" scoped>
.dialog_box {
  width: 100%;
  margin-top: 20px;
  box-sizing: border-box;
}
.dialog_footer {
  width: 100%;
  text-align: end;
  padding-bottom: 20px;
  button {
    padding: 0 20px !important;
  }
}
</style>
